if (!customElements.get('product-recommendations-mattress')) {
  class MattressRecommendations extends ProductRecommendations {
    constructor() {
      super();
      this.product = this.closest(".product");
      this.cart = this.closest(".dpx-main-cart") || this.closest("cart-drawer");
      this.addListeners();
    }

    addListeners() {
      if (this.product) {
        this.product.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }
      if (this.cart) {
        this.buttons = this.querySelectorAll(".js-mattress-quick-add");
        this.buttons.forEach((button)=>{
          button.addEventListener("click", this.handleAddBtnClick.bind(this));
        });
      }

    }

    handleVariantChange(event) {
      const variantOptions = event.detail.variant.options.map(v => v.toLowerCase().replace(/ /g,'-'));
      const upsells = this.querySelectorAll(".mattress-upsell");
      upsells.forEach((upsell) => {
        upsell.price = upsell.querySelector(".price__current");
        upsell.input = upsell.querySelector("input[name='id']");
        upsell.data = JSON.parse(upsell.querySelector(".mattress-ids").textContent);
        const variant = upsell.data[variantOptions.find(key => upsell.data.hasOwnProperty(key))];

        if (variant) {
          upsell.classList.remove("hidden");
          upsell.price.innerHTML = variant.price;
          upsell.input.value = variant.id;
          if(variant.available) {
            upsell.classList.remove("hidden");
          } else {
            upsell.classList.add("hidden");
          }
        } else {
          upsell.classList.add("hidden");
        }
      })
    }

    handleAddBtnClick(evt) {
      evt.preventDefault();
      const variant_id = evt.target.parentElement.querySelector("input[name='id']").value;
      const upsellForm = document.querySelector("#mattress-upsell-pf");
      const cartItems = this.closest("cart-items");
      const loader = cartItems.querySelector('.cart-item__loader');
      upsellForm.querySelector("input[name='id']").value = variant_id;
      upsellForm.init();
      cartItems.classList.add("pointer-events-none");
      if (loader) loader.hidden = false;
      upsellForm.querySelector("button").click();
    }
  }

  customElements.define('product-recommendations-mattress', MattressRecommendations);
}